import { render, staticRenderFns } from "./product_schema.vue?vue&type=template&id=0afeb10f&scoped=true"
import script from "./product_schema.vue?vue&type=script&lang=js"
export * from "./product_schema.vue?vue&type=script&lang=js"
import style0 from "./product_schema.vue?vue&type=style&index=0&id=0afeb10f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afeb10f",
  null
  
)

export default component.exports